<nz-spin [nzSpinning]="submitted" nzSize="large">
  <form nz-form [nzLayout]="'vertical'" (ngSubmit)="simulateCar()" [formGroup]="simulateForm"
        aria-labelledby="sub-title"
        class="store-form">

    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-year">Car Year</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <nz-select nzPlaceHolder="Car Year" formControlName="carYear" (ngModelChange)="onCarYearChange($event)"
                   nzSize="large">
          <nz-option *ngFor="let year of yearList" [nzValue]="year" [nzLabel]="year"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-make">Car Make</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <nz-select nzPlaceHolder="Car Make" formControlName="carMake" (ngModelChange)="onCarMakeChange($event)"
                   nzSize="large">
          <nz-option *ngFor="let make of makeList" [nzValue]="make.name" [nzLabel]="make.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-model">Car Model</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <nz-select nzPlaceHolder="Car Model" formControlName="carModel" nzSize="large">
          <nz-option *ngFor="let model of modelList" [nzValue]="model.name" [nzLabel]="model.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-model">Model Type</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <nz-select nzPlaceHolder="Model Type" formControlName="modelType" nzSize="large" [nzMode]="'default'">
          <nz-option *ngFor="let model of modelTypes" [nzValue]="model" [nzLabel]="model"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-make">Mileage</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <input nz-input formControlName="mileage" id="mileage" nzSize="large" placeholder="Enter Mileage" type="number">
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-make">Zip Code</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <input nz-input formControlName="zipCode" id="zip-code" nzSize="large" placeholder="Enter ZipCode"
               type="number">
      </nz-form-control>
    </nz-form-item>

    <div nz-row>
      <div nz-col nzSpan="12" nzOffset="6">
        <button nz-button nzType="primary" nzSize="large" nzBlock [nzLoading]="submitted" type="submit"
                [disabled]="submitted || simulateForm.invalid" [class.btn-pulse]="submitted">
          Simulate Model
        </button>
      </div>
    </div>
  </form>
</nz-spin>
